import React from "react";
import { ArrowLeft } from "lucide-react";

import "./BackButton.css";

const BackButton = ({
  onClick,
  label = "Back",
  disabled = false,
  iconSize = 18,
  className = "",
}) => {
  return (
    <button
      type="button"
      className={`back-button ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      <ArrowLeft size={iconSize} />

      <span className="back-button__label">{label}</span>
    </button>
  );
};

export default BackButton;
